import { Outlet } from "react-router-dom";

const AssetService = () => {
  return <Outlet />;
};

export default AssetService;
